import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=72ae4804&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=72ae4804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae4804",
  null
  
)

export default component.exports